import script from "./TimelineEventRow.vue?vue&type=script&setup=true&lang=js"
export * from "./TimelineEventRow.vue?vue&type=script&setup=true&lang=js"

import "./TimelineEventRow.vue?vue&type=style&index=0&id=479e8703&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-479e8703"]])

export default __exports__